import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  LogOutIcon,
  // UrbanCompassLogo,
  UrbanCompassLogoBlack,
} from '../../../icons';
import { useAuth } from '../../../hooks/useAuth';
import { useLanguage } from '../../../hooks/useLanguageSwitch';
import DropDown from '../../../components/uielements/dropDown';
import { getLanguageLabel, languageOptions } from '../../pages/chatBot/constant';
import { IntlMessages } from '../../../helper/langHelper';
import {
  clearCache,
  clearCacheOverlaysScreenshots,
  clearSummaryCache,
} from '../../../helper/cacheHelper';
import { clearItem } from '../../../helper/localStorageHelper';
import { LogOut, Plus } from 'lucide-react';
import ConfirmationModal from '../../../components/uielements/modal/confirmationModal';
import useOverlayStore from '../../../store/overlayStore';
import useShapeStore from '../../../store/shapeStore';
import { useQueryClient } from '@tanstack/react-query';
import Cache from '../../../helper/globalCacheHelper';
import EnquiryModal from './modal/enquiryModal';

import {
  Nav,
  Logo,
  DesktopActions,
  CreateApplicationButton,
  LogoutButton,
  MobileMenuButton,
  MobileMenu,
  MobileMenuClose,
  MobileMenuItem,
} from './navbar.styles';

const Navbar = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const isPromptScreen =
    location.pathname === '/promptSelect' || location.pathname === '/addressSearch';

  const isQuestionScreen = location.pathname === '/generateQuestion';

  const isInitialPage = location.pathname === '/';

  // const isApplicationPage = location.pathname === '/applications';

  const isSpecificRoute =
    location.pathname === '/reportReview' ||
    location?.pathname?.includes('application') ||
    location.pathname === '/preLodgementReport' ||
    location.pathname === '/documentUpload' ||
    location.pathname === '/analytics' ||
    location.pathname === '/analyticsDetails' ||
    location.pathname === '/';

  const { logout } = useAuth();
  const languageChanged = useLanguage();

  const [confirmation, setConfirmation] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Mobile navbar state
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const { clearOverlayData } = useOverlayStore();
  const { resetAll } = useShapeStore();
  const queryClient = useQueryClient();

  const handleLogout = () => {
    queryClient.clear();
    queryClient.removeQueries();
    clearCache();
    clearSummaryCache();
    Cache.clearAllCaches();
    clearCacheOverlaysScreenshots();
    clearItem('applicationId');
    clearItem('procedure');
    clearItem('screenshotId');
    clearItem('image-store');
    clearItem('procedurePermit');
    clearOverlayData();
    resetAll();

    logout();

    navigate('/', { replace: true });

    setIsMobileMenuOpen(false);
  };

  const handleAddressSearch = () => {
    clearCacheOverlaysScreenshots();
    setIsModalOpen(true);

    setIsMobileMenuOpen(false);
  };

  const handleConfirmation = () => {
    setConfirmation(false);
    clearOverlayData();
    clearCacheOverlaysScreenshots();
    resetAll();

    // navigate('/applications', { replace: true });

    navigate('/', { replace: true });

    setIsMobileMenuOpen(false);
  };

  const handleSetSelectedLangIntoLocalStorage = (lang) => {
    if (lang) {
      languageChanged.setLanguage(lang.value);
    }
  };

  const handleCreateClick = () => {
    if (isInitialPage) {
      handleAddressSearch();
    } else {
      setConfirmation(true);
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <Nav
      isBackground={isPromptScreen}
      isQuestionScreen={isQuestionScreen}
      isSpecificRoute={isSpecificRoute}
    >
      <Logo>
        {/* {isInitialPage ? (
          <UrbanCompassLogo onClick={() => navigate('/')} />
        ) : (
          <UrbanCompassLogoBlack onClick={() => navigate('/')} />
        )} */}

        {/* {isInitialPage ? (
          <CityOfOretonLogo color={'#fff'} onClick={() => navigate('/')} />
        ) : ( */}

        <UrbanCompassLogoBlack color={'#000'} onClick={() => navigate('/')} />

        {/* )} */}
      </Logo>

      <DesktopActions>
        {/* <CreateApplicationButton onClick={() => navigate('/analytics')}>
          Admin View
        </CreateApplicationButton> */}

        <CreateApplicationButton
          onClick={isInitialPage ? handleAddressSearch : () => setConfirmation(true)}
          className="create_application_button"
        >
          {/* {isApplicationPage ? ( */}
          <>
            <Plus />
            <IntlMessages id="button.label.create" />
          </>
          {/* ) : (
            <IntlMessages id="button.label.dashboard" />
          )} */}
        </CreateApplicationButton>

        {/* {!isInitialPage && ( */}
        <DropDown
          options={languageOptions}
          selectedOption={handleSetSelectedLangIntoLocalStorage}
          label={getLanguageLabel(languageChanged?.selectedLang) || 'Choose Language'}
          width="180px"
        />
        {/* )} */}

        <LogoutButton onClick={handleLogout}>
          <LogOutIcon />
          <IntlMessages id="button.logout" />
        </LogoutButton>
      </DesktopActions>

      {/* MOBILE HAMBURGER */}
      <MobileMenuButton
        type="button"
        aria-label="Open menu"
        aria-expanded={isMobileMenuOpen}
        onClick={() => setIsMobileMenuOpen(true)}
      >
        <span />
        <span />
        <span />
      </MobileMenuButton>

      {/* MOBILE MENU */}
      {isMobileMenuOpen && (
        <MobileMenu>
          <MobileMenuClose
            type="button"
            aria-label="Close menu"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            ×
          </MobileMenuClose>

          <MobileMenuItem type="button" onClick={handleCreateClick}>
            <Plus />

            <span>
              <IntlMessages id="button.label.create" />
            </span>
          </MobileMenuItem>

          <MobileMenuItem type="button" onClick={handleLogout}>
            <LogOut />

            <span>
              <IntlMessages id="button.logout" />
            </span>
          </MobileMenuItem>
        </MobileMenu>
      )}

      <ConfirmationModal
        isModalOpen={confirmation}
        onClose={() => setConfirmation(false)}
        onConfirm={handleConfirmation}
        title={<IntlMessages id="confirmation.title" />}
        message={<IntlMessages id="confirmation.message" />}
        confirmText={<IntlMessages id="button.label.yes" />}
        cancelText={<IntlMessages id="button.label.cancel" />}
      />

      <EnquiryModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </Nav>
  );
};

export default Navbar;
